exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tags .input-box.as-input[data-v-a0d718c4] {\n  border: 1px solid #dcdfe6;\n  padding-left: 6px;\n  font-size: 12px;\n  min-height: 32px;\n  line-height: 30px;\n  border-radius: 4px;\n  background: #fff;\n  color: #606266;\n  cursor: pointer;\n}\n.tags .org-tag[data-v-a0d718c4] {\n  margin-right: 6px;\n  max-width: 6rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  position: relative;\n  padding-right: 1rem;\n  vertical-align: middle;\n}\n.tags .org-tag[data-v-a0d718c4] .el-tag__close {\n  position: absolute;\n  right: 2px;\n  top: 50%;\n  margin-top: -7px;\n}\n", ""]);

// exports
